<template>
  <b-card no-body>
    <b-card-header>
      <!-- title and subtitle -->
      <div>
        <b-card-title class="mb-1">
          فروش
        </b-card-title>
      </div>
      <!--/ title and subtitle -->
      <!--/ badge -->
    </b-card-header>
    <b-card-body>
      <div>
        <b-row>
          <b-col md="4">
            <div class="d-flex ">
              <div
                style="width:100px"
                class="mr-2"
              >
                <p style="margin: 0">
                  از تاریخ
                </p>
                <date-picker
                  v-model="chart.fromDate"
                  placeholder=""
                />
              </div>
              <div
                style="width:100px"
                class="mr-2"
              >
                <p style="margin: 0">
                  تا تاریخ
                </p>
                <date-picker
                  v-model="chart.toDate"
                  placeholder=""
                  :min="chart.fromDate"
                />
              </div>
              <div class="d-flex flex-column justify-content-end">
                <b-button
                  v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                  variant="info"
                  style="height:fit-content;width:85px"
                  @click="refreshData()"
                >
                  <span>اعمال</span>
                </b-button>
              </div>
            </div>
            <div class="d-flex mt-2">
              <div
                style="width:100px"
                class="mr-2"
              >
                <p style="margin: 0">
                  از تاریخ
                </p>
                <date-picker
                  v-model="chart.compare_fromDate"
                  placeholder=""
                />
              </div>
              <div
                style="width:100px"
                class="mr-2"
              >
                <p style="margin: 0">
                  تا تاریخ
                </p>
                <date-picker
                  v-model="chart.compare_toDate"
                  placeholder=""
                  :min="chart.compare_fromDate"
                  :max="chart.maxCompareDate"
                />
              </div>
              <div class="d-flex flex-column justify-content-end">
                <div class="d-flex">
                  <b-button
                    v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                    variant="info"
                    style="height:fit-content;width:85px"
                    :disabled="disableCompareFields"
                    @click="chartForCompare"
                  >
                    <span>مقایسه</span>
                  </b-button>
                  <b-button
                    v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                    variant="info"
                    class="d-inline-block ml-1"
                    style="height:fit-content;width:85px;"
                    :disabled="disableCompareFields"
                    @click="removeCompareCharts"
                  >
                    حذف
                  </b-button>
                </div>
              </div>
            </div>
          </b-col>
          <b-col md="8">
            <b-table
              :items="items"
              :fields="fields"
              responsive
              :no-local-sorting="true"
              borderless
              small
            >
              <template #cell()="data">
                <div class="text-center">
                  <b-button
                    v-if="data.field.key !== 'a'"
                    v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                    size="sm"
                    variant="outline-info"
                    @click="toggleMainChart($event,data)"
                  >
                    <span>
                      <BIconBarChartFill />
                    </span>
                  </b-button>
                  <span v-else>{{ data.value }}</span>
                </div>
              </template>
            </b-table>
          </b-col>
        </b-row>
      </div>
      <div>
        <b-overlay
          :show="loading"
          rounded="sm"
        >
          <vue-apex-charts
            ref="chart"
            type="line"
            height="400"
            :options="apexChartData.chartOptions"
            :series="apexChartData.series"
          />
        </b-overlay>
      </div>
    </b-card-body>

  </b-card>
</template>

<script>
import {
  BCard, BCardBody, BCardHeader, BCardTitle, BCardSubTitle, BBadge, BIconBarChartFill,
} from 'bootstrap-vue'
import VueApexCharts from 'vue-apexcharts'
import { $themeColors } from '@themeConfig'

export default {
  name: 'SellReport',
  components: {
    VueApexCharts,
    BCardHeader,
    BCard,
    BBadge,
    BCardBody,
    BCardTitle,
    BCardSubTitle,
    BIconBarChartFill,
  },
  data() {
    return {
      apexChartData: {
        series: [],
        chartOptions: {
          chart: {
            fontFamily: 'IranSans',
            zoom: {
              enabled: false,
            },
            toolbar: {
              show: false,
            },
          },
          markers: {
            strokeWidth: 7,
            strokeOpacity: 1,
            strokeColors: [$themeColors.light],
            colors: [$themeColors.warning],
          },
          colors: [],
          dataLabels: {
            enabled: false,
          },
          stroke: {
            curve: 'straight',
          },
          grid: {
            xaxis: {
              lines: {
                show: true,
              },
            },
          },
          tooltip: {
            custom(data) {
              return `${'<div class="px-1 py-50"><span>'}${
                data.series[data.seriesIndex][data.dataPointIndex]
              }</span></div>`
            },
          },
          xaxis: {
            categories: [],
          },
          yaxis: {
            // opposite: isRtl,
          },
          legend: {
            showForSingleSeries: true,
          },
        },
      },
      chart: {
        product: null,
        bank: null,
        fromDate: null,
        toDate: null,
        compare_fromDate: null,
        compare_toData: null,
        maxCompareDate: null,
      },
      loading: false,
      fields: [],
      items: [],
    }
  },
  computed: {
    disableCompareFields() {
      return (this.chart.compare_fromDate === null && this.chart.compare_toData === null)
    },
    daysBtwFDateAndTDate() {
      const from = this.$moment(this.chart.fromDate)
      const to = this.$moment(this.chart.toDate)
      return to.diff(from, 'days')
    },
  },
  watch: {
    'chart.compare_fromDate': function (val) {
      if (val !== null) {
        this.chart.maxCompareDate = this.$moment(this.chart.compare_fromDate).add(this.daysBtwFDateAndTDate, 'days').format('YYYY/MM/DD')
        this.chart.compare_toDate = this.chart.maxCompareDate
      }
    },
    'chart.fromDate': function () {
      this.chart.compare_fromDate = null
      this.chart.compare_toData = null
    },
  },
  created() {
    this.items = [
      ...this.enums('products').map(product => ({
        a: product.text,
        value: product.value,
      })),
    ]
    this.fields = [
      {
        key: 'a',
        value: '',
        variant: 'info',
        class: 'text-center',
      },
      ...this.enums('bank').map(bank => ({
        key: bank.text,
        value: [bank.value],
        class: 'text-center',
      })),
      {
        key: 'تجمیع',
        value: [],
        class: 'text-center',
      },
    ]
    this.chart.fromDate = this.$moment().startOf('jMonth').format('YYYY/MM/DD')
    this.chart.toDate = this.$moment().endOf('jMonth').format('YYYY/MM/DD')
    this.setXaxisCategory()
  },
  methods: {
    toggleMainChart(e, data) {
      const seriesName = this.seriesNameForMainChart(data)
      const nameWithoutDate = `${data.item.a} - ${data.field.label}`
      const product = data.item.value
      const bank = data.field.value
      const typeChart = 'mainChart'
      e.currentTarget.classList.toggle('btn-info')
      if (!this.isExistChart(seriesName)) {
        this.getChartData(product, bank, seriesName, this.chart.fromDate, this.chart.toDate).then(chartData => {
          this.addNewChart(
            seriesName,
            chartData.data,
            product,
            bank,
            typeChart,
            nameWithoutDate,
          )
        }).finally(() => { this.loading = false })
      } else this.removeChart(seriesName)
    },
    addNewChart(seriesName, chartData, product, bank, typeChart, nameWithoutDate) {
      this.apexChartData.series.push(
        {
          name: seriesName,
          data: chartData,
          id: seriesName,
          product,
          bank,
          typeChart,
          nameWithoutDate,
        },
      )
      this.apexChartData.chartOptions.colors.push(this.getRandomColor())
    },
    chartForCompare() {
      this.apexChartData.series.forEach(series => {
        if (series.typeChart === 'mainChart') {
          const seriesName = this.SeriesNameForCompareChart(series.nameWithoutDate)
          this.getChartData(series.product, series.bank, seriesName, this.chart.compare_fromDate, this.chart.compare_toDate).then(chartData => {
            this.addNewChart(seriesName, chartData.data, series.product, series.bank, 'compareChart')
          })
        }
      })
    },
    getChartData(product, bank, id, fromDate, toDate) {
      this.loading = true
      return new Promise(resolve => {
        this.$http.post(this.$api.report.sellReport, {
          FromDate: fromDate,
          ToDate: toDate,
          DietDurationPriceId: product,
          Bank: bank,
          IsPaid: true,
          CouponId: [],
        }).then(response => {
          const seriesData = response.data.map(re => re.Price)
          this.loading = false
          resolve({
            data: seriesData, id, product, bank,
          })
        }).finally(() => { this.loading = false })
      })
    },
    setXaxisCategory() {
      const categories = []
      const from = this.$moment(this.chart.fromDate)
      const to = this.$moment(this.chart.toDate)
      const days = to.diff(from, 'days')
      for (let i = 0; i <= days; i++) {
        const category = this.$moment(from)
          .add(i, 'day')
          .format('jM/jD')
        categories.push(category)
      }
      this.apexChartData.chartOptions = {
        ...this.apexChartData.chartOptions,
        xaxis: {
          categories,
        },
      }
    },
    refreshData() {
      const charts = []
      this.chart.compare_fromDate = null
      this.chart.compare_toDate = null
      this.apexChartData.series.forEach(series => {
        if (series.typeChart === 'mainChart') charts.push(this.getChartData(series.product, series.bank, series.id, this.chart.fromDate, this.chart.toDate))
      })
      if (charts.length === 0) {
        return true
      }
      Promise.all(charts).then(data => {
        const result = []
        data.forEach(d => {
          result.push(
            {
              name: d.id,
              data: d.data,
              product: d.product,
              bank: d.bank,
              typeChart: 'current',
            },
          )
        })
        this.$refs.chart.updateSeries(result)
        this.setXaxisCategory()
      })
    },
    SeriesNameForCompareChart(seriesName) {
      let name = ''
      const fromData = this.$moment(this.chart.compare_fromDate).format('jYY/jM/jD')
      const toDate = this.$moment(this.chart.compare_toDate).format('jYY/jM/jD')
      name += `مقایسه ${seriesName} <br> ${fromData} - ${toDate}`
      return name
    },
    seriesNameForMainChart(data) {
      const fromDate = this.$moment(this.chart.fromDate).format('jYY/jM/jDD')
      const toDate = this.$moment(this.chart.toDate).format('jYY/jM/jDD')
      const seriesName = `${data.item.a} - ${data.field.label} <br> ${fromDate} - ${toDate}`
      return seriesName
    },
    removeCompareCharts() {
      const indexes = this.getAllIndexes(this.apexChartData.series, 'compareChart')
      this.apexChartData.series = this.apexChartData.series.filter(chart => chart.typeChart !== 'compareChart')
      indexes.forEach(index => {
        this.apexChartData.chartOptions.colors.splice(index, 1)
      })
    },
    removeChart(seriesName) {
      const indexOfSeries = this.apexChartData.series.findIndex(series => series.id === seriesName)
      this.apexChartData.chartOptions.colors.splice(indexOfSeries, 1)
      this.apexChartData.series = this.apexChartData.series.filter(chart => chart.id !== seriesName)
    },
    isExistChart(id) {
      return this.apexChartData.series.some(chart => chart.id === id)
    },
    getAllIndexes(arr, val) {
      const indexes = []
      let i
      for (i = 0; i < arr.length; i++) if (arr[i].typeChart === val) indexes.push(i)
      return indexes
    },
    getRandomColor() {
      const letters = '0123456789ABCDEF'
      let color = '#'
      for (let i = 0; i < 6; i++) {
        color += letters[Math.floor(Math.random() * 16)]
      }
      return color
    },
  },
}
</script>
<style>
[dir] .table-info, [dir] .table-info > th, [dir] .table-info > td {
  background-color: #f3f2f7
}
.apexcharts-legend-text{
  margin-right: 10px;
  margin-left: 10px;
  width: 150px;
  line-height:1.5
}
</style>
